import { FormStateEnum } from "./../../models/formCustomRoute.models";
import WebComponent from '../base/WebComponent';

class StepForm extends WebComponent {
    static observedAttrs = ['current-route'];
    currentRoute = 0;
    currentElement = "step-not-found";
    isMobile = window.matchMedia("(max-width: 768px)").matches;
    props = {
        routes: [], 
        data: {}
    };

    connectedCallback() {
        if (this['current-route']) {
            this.currentRoute = parseInt(this['current-route']);
        }
        if(this.render) this.render();
        this.centerToSection();
    }

    formNavigate = (index) => {
        this.currentRoute = index;

        if (this.props.routes[this.currentRoute] !== null) {
            this.currentElement = "step-not-found";
        }

        this.currentElement = this.currentRouteData().component;

        this.render();
        this.centerToSection();
    }

    centerToSection() {
        setTimeout(() => {
            const elementPosition = document.querySelector('[ref="currentElement"]')?.getBoundingClientRect().top;
            const headerOffset = document.querySelector('.header-container').offsetHeight + 18;

            window.scrollTo({
                top: elementPosition + window.pageYOffset - headerOffset,
                behavior: "smooth"
            });
        }, 250);
    }

    currentRouteData() {
        return this.props.routes[this.currentRoute];
    }

    isStateSuccess(test) {
        return test === FormStateEnum.success;
    }

    setProps(props) {
        this.props = props;
        this.currentElement = this.props.routes[this.currentRoute].component;
        if(this.render) this.render();
    }

    mounted() {
        if (this.currentElement != null) {
            this.setTargetProps({target: '[ref="currentElement"]', props: {
                data: this.props.data,
                index: this.currentRoute,
                handler: this.props.handler,
                navhandler: this.formNavigate,
                active: true,
                route: this.currentRouteData()
            }})
        }

        this.props.routes.forEach((route, key) => {
            this.setTargetProps({target: `[ref="stepNavItem${key}"]`, props: {
                index: key,
                headline: route.alias,
                text: route.description,
                active: key === this.currentRoute,
                state: route.state,
                handler: this.formNavigate
            }})
        })
    }

    template() {
        return `
            <article class="stepform">
                ${this.currentElement != null ? `<${this.currentElement} ref="currentElement" class="stepform__content"></${this.currentElement}>` : ""}
                <div class="stepform__nav-wrap">
                    <nav class="stepform__nav">
                        ${this.wFor(this.props.routes, (route, key) => {
                            return `<step-nav-item ref="stepNavItem${key}"></step-nav-item>`
                        })}
                    </nav>
                </div>
            </article>
        `;
    }
  }
  
  // register component
  customElements.define( 'step-form', StepForm );

